/// <reference path="../include.ts" />

namespace gpx_visualizer_phase2 {

	import View = alm.view.View;

	export class ErrorDialog extends View<JQuery> {

		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		constructor() {
			super(jQuery('#error-dialog'));

			this.initialize();
		}





		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		protected implInitialize():JQuery {
			ErrorDialog.instance = this;

			const view = this.getView();
			this.textField = view.find('.message');

			return view;
		}

		protected implReady():void {
		}

		protected implFinalize():void {
		}

		protected implShow(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'block');
			});
		}

		protected implHide(view:JQuery, useTransition:boolean):cmd.Command {
			return new cmd.Func(():void => {
				view.css('display', 'none');
			});
		}





		private setMessage(message:string):void {
			this.textField.html(message);
		}





		public static show(message:string, statusCode:number, useTransition:boolean = true):void {
			trace('[ErrorDialog] show : \'' + message + '\', status code =', statusCode);

			this.instance.setMessage(message);
			this.instance.show(useTransition);

			Loading.hide(false);
		};

		public static hide(useTransition:boolean = true):void {
			this.instance.hide(useTransition);
		};





		// --------------------------------------------------
		//
		// VARIABLE
		//
		// --------------------------------------------------

		private textField:JQuery;

		private static instance:ErrorDialog = null;
	}
}
